import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../Svg';
import Option from './Option';
import classNames from 'classnames';

const OptionsList = props => (
    <div
        className={classNames('sales__dropdown ui-filter ui-popover', { hidden: !props.opened })}
    >
        <div className="ui-dropdownPointer" />
        <div className="ui-filter__header ui-popoverHeader">
            <span className="ui-filter__title">{props.title}</span>
            <button
                className="ui-btn ui-btn_secondary ui-filter__header__button"
                onClick={props.onCancelClick}
            >
                <Svg size="Medium" iconName="cross" />
            </button>
        </div>
        <div className="ui-filter__gradient ui-filter__gradient_top" />
        <div className="ui-filter__body">
            <section>
                <ul className="ui-filter__list">
                    {props.options.map(option =>
                        <Option
                            key={option.value}
                            value={option.value}
                            displayName={option.displayName}
                            selected={option.value === props.selected}
                            onOptionClick={props.onOptionClick}
                        />
                    )}
                </ul>
            </section>
        </div>
    </div>
);

OptionsList.propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onOptionClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    opened: PropTypes.bool,
    selected: PropTypes.any
};

export default OptionsList;



// WEBPACK FOOTER //
// ./src/js/modules/Dropdown/components/OptionsList.js